module.exports = __webpack_public_path__ + "static/media/inviteSuccess.47185e5a.png";